export default __webpack_public_path__ + "static/fin-ins-fraud-fd548ef23e36f43f76dd275f80e9395c.png";